export default __webpack_public_path__ + "static/media/IMAGEM DOS PRODUTOS - hiperrfoco_.43abc4bb.png";